import { render, staticRenderFns } from "./modalComentarios.vue?vue&type=template&id=07965298&scoped=true"
import script from "./modalComentarios.vue?vue&type=script&lang=js"
export * from "./modalComentarios.vue?vue&type=script&lang=js"
import style0 from "./modalComentarios.vue?vue&type=style&index=0&id=07965298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07965298",
  null
  
)

export default component.exports